export default __webpack_public_path__ + "static/media/item-forma-de-pago-azul.d731bc5c.svg";